import React from 'react';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { insertRecommendation } from '../pm-plugins/ai-proactive/commands';
import { getPluginState as getProactivePluginState } from '../pm-plugins/ai-proactive/plugin-factory';
import { getSelectedRecommendations } from '../pm-plugins/ai-proactive/utils';
import { getPluginState as getDecorationPluginState } from '../pm-plugins/decoration/decoration-plugin-factory';
import { RecommendationList } from './recommendation-list';
export var getContextPanel = function getContextPanel(getEditorView) {
  return function (api) {
    return function (state) {
      // FIXME: future implementation of suggestion sidebar
      // get relavent plugin states from proactive to find the list of suggestions to recommend
      // EIther plugin can trigger this sidecar to open, by setting a flag in state.
      // we might also open context panel based on similar trigger with how floating toolbar works, maybe...

      var proactivePluginState = getProactivePluginState(state);
      if (proactivePluginState) {
        var isProactiveEnabled = proactivePluginState.isProactiveEnabled;
        // FIXME: Decide on the correct trigger for opening/closing the context panel. Currently the context panel
        // will just open as soon as there a recommendations. This is for testing purposes only.
        if (isProactiveEnabled && state.selection.from === state.selection.to) {
          var decorationPluginState = getDecorationPluginState(state);
          if (decorationPluginState.modalDecorationSet === DecorationSet.empty) {
            var selectedRecommendations = getSelectedRecommendations(proactivePluginState, state.selection.to);
            if (!selectedRecommendations) {
              return;
            }

            // FIXME: Pass necesary actions to apply/dismiss the recommendations.
            // FIXME: Update UI once design is finalised.
            return /*#__PURE__*/React.createElement(RecommendationList, {
              recommendations: selectedRecommendations,
              onApply: function onApply(_ref) {
                var _api$contextPanel;
                var recommendation = _ref.recommendation;
                var editorView = getEditorView === null || getEditorView === void 0 ? void 0 : getEditorView();
                if (!editorView) {
                  return null;
                }
                // TODO: review this logic.
                var matchingBlock = proactivePluginState.proactiveAIBlocks.find(function (block) {
                  return block.id === recommendation.chunkId;
                });
                if (!matchingBlock) {
                  return;
                }
                var applyChange = api === null || api === void 0 || (_api$contextPanel = api.contextPanel) === null || _api$contextPanel === void 0 ? void 0 : _api$contextPanel.actions.applyChange;
                insertRecommendation(matchingBlock, recommendation, applyChange)(editorView.state, editorView.dispatch);
              },
              onDismiss: function onDismiss(_ref2) {
                var recommendation = _ref2.recommendation;
              } // FIXME: Dismiss the recommendation from the list.
            });
          }
        }
      }
    };
  };
};